import { NavLink } from "react-router-dom";

import { NavigationGroup } from "@/types/navigation";
import { cn } from "@/utils";

type SecondaryNavigationProps = {
  navigations: NavigationGroup[];
};

export function SecondaryNavigation({ navigations }: SecondaryNavigationProps) {
  return (
    <nav className="flex flex-1 flex-col">
      <ul className="flex flex-1 flex-col gap-y-7">
        {navigations.map((navigation, index) => (
          <li key={navigation.name ?? index}>
            {navigation.name && (
              <p className="flex items-center gap-x-2 p-2 text-sm font-semibold">
                {navigation.icon && (
                  <navigation.icon
                    aria-hidden="true"
                    className="size-4 shrink-0 text-inherit"
                  />
                )}
                {navigation.name}
              </p>
            )}
            <ul>
              {navigation.elements.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.href}
                    className={({ isActive }) =>
                      cn(
                        "flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary",
                        isActive && "bg-muted text-primary",
                      )
                    }
                  >
                    {item.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  );
}
